import {
    AfterViewChecked,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';

@Component({
    selector: 'tyl-quill-text-only',
    templateUrl: './quill-text-only.component.html',
    styleUrls: ['./quill-text-only.component.css']
})
export class QuillTextOnlyComponent implements OnInit, AfterViewChecked, OnDestroy {
    private _width = '';
    private _height = '';
    private _padding;
    private _displayBorder = false;
    @Input() html = '';
    @Input() placeholder = '';
    @ViewChild('quill', { static: true }) quill: QuillEditorComponent;
    quillContentContainer: HTMLDivElement;

    get width(): string {
        return this._width;
    }

    @Input() set width(value: string) {
        this._width = value != null ? value : '';
    }

    get height(): string {
        return this._height;
    }

    @Input() set height(value: string) {
        this._height = value != null ? value : '';
    }

    get displayBorder(): boolean {
        return this._displayBorder;
    }

    @Input() set displayBorder(value: boolean) {
        this._displayBorder = value != null ? value : true;
    }

    get padding(): number {
        return this._padding;
    }

    @Input() set padding(value: number) {
        this._padding = value;
        if (this.quillContentContainer && this._padding != null) {
            this.quillContentContainer.style.padding = this._padding + 'px';
        }
    }

    constructor(
        private elementRef: ElementRef
    ) {
    }

    ngOnInit() {
        if (this.html != null) {
            this.html = this.html.replace(/\n/g, '<br />');
        }
    }

    ngAfterViewChecked(): void {
        this.quill.placeholder = this.placeholder;
        this.quill.formats = [
            'background',
            'bold',
            'color',
            'code',
            'font',
            'italic',
            'link',
            'size',
            'strike',
            'script',
            'underline',
            'blockquote',
            'header',
            'indent',
            'list',
            'align',
            'direction',
            'code-block',
            'image'
        ];
        this.quillContentContainer = this.elementRef.nativeElement.getElementsByClassName('ql-editor').item(0);
        if (this.quillContentContainer && this._padding != null) {
            this.quillContentContainer.style.padding = this.padding + 'px';
        }
    }

    ngOnDestroy() {
        if (this.quill.modules != null) {
            this.quill.modules = [];
        }
    }
}
